import {Trade} from "../../../types/APITypes";
import {DateTime} from 'luxon';
import {convertToDateTime, fromJSDateToDateTime} from "../TradeFormatUtils";
import {executeInTheNextEventLoopTick} from "@mui/x-date-pickers/internals";

export async function formatVocsetTrade(tradeData: Trade): Promise<Trade> {
    // initialise by copying over all the fields
    const mappedData: Trade = tradeData;

    mappedData.sourceSystem = 'VOCSET';

    mappedData.side= tradeData.side?.toUpperCase().startsWith('B') ? 'Buy' : tradeData.side?.toUpperCase().startsWith('S') ? 'Sell' : undefined;
    mappedData.optionType = tradeData['optionType']?.toUpperCase().startsWith('P') ? 'Put' : tradeData['optionType']?.toUpperCase().startsWith('C') ? 'Call' : undefined;
    mappedData.assetClass = tradeData.optionType || tradeData.strike ? 'Option' : 'Future';

    // @ts-ignore
    mappedData.tradeDate = convertToDateTime(tradeData.tradeDate)?.toISODate();

    // @ts-ignore
    mappedData.executionTime = convertToDateTime(tradeData.executionTime)?.toISO();

    // @ts-ignore
    mappedData.giveupTime = convertToDateTime(tradeData.giveupTime)?.toISO();

    // @ts-ignore
    mappedData.maturity = convertToDateTime(tradeData.maturity)?.toISODate();

    mappedData.clearingAccount = mappedData.clearingAccount?.toString();
    mappedData.executingAccount = mappedData.executingAccount?.toString();
    mappedData.tradeID = mappedData.tradeID?.toString();

    return mappedData;
}
